import { faCheck } from '@awesome.me/kit-379289146f/icons/classic/solid';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Stack, Switch, Typography } from '@mui/material';
import { useFormContext, useWatch } from 'react-hook-form';

import { ControlledInputs } from '@/components';
import { omit } from '@/utils';

import { productTabs } from '../data/product-tabs';
import { SubscriptionForm } from '../hooks';
import { ProductDetailsType } from '../store';

import {
  BodyContainer,
  ButtonContainer,
  CardBody,
  CardDescription,
  CardGst,
  CardPrice,
  CardTitle,
  CardTitleType,
  CardUsers,
} from './Filters.components';

type ProductCardProps = ProductDetailsType & {
  length: number;
  active: number;
};

export const ProductCard = (props: ProductCardProps) => {
  const form = useFormContext<SubscriptionForm>();

  const { setValue } = form;
  const { users, active } = props;
  const product = productTabs[active].value;
  const { type } =
    useWatch({
      name: product,
      control: form.control,
    }) ?? {};

  const handleChange = (data: ProductCardProps) => {
    if (type === data.type) setValue(product, null);
    else setValue(product, omit(data, ['active', 'length']));
  };

  return (
    <Stack>
      <CardTitleType>
        <CardTitle>{props.type}</CardTitle>
        <CardDescription>{props.description}</CardDescription>
      </CardTitleType>
      <CardBody>
        <Stack direction="row">
          <CardPrice>${props.price}</CardPrice>
          <CardGst>
            + GST{' '}
            {props?.type.toLowerCase().includes('enterprise') && ' Per person'}
          </CardGst>
        </Stack>
        <CardUsers>
          Monthly | 12-month contract |
          {users?.min !== '0'
            ? users.max === '0'
              ? ` ${users.min}+ users`
              : ` ${users.min} - ${users.max} users`
            : ` Up to ${users.max} users`}
        </CardUsers>
        <ButtonContainer>
          <Stack direction="row" gap={2}>
            Select Package
            {props.type.toLowerCase().includes('enterprise') && (
              <ControlledInputs.TextField
                ControllerProps={{
                  control: form.control,
                  name: `${product}.count`,
                }}
                disabled={
                  !(
                    type !== undefined &&
                    type.toLowerCase().includes('enterprise')
                  )
                }
                sx={{
                  width: 40,
                }}
              />
            )}
          </Stack>
          <Switch
            onChange={() => handleChange(props)}
            checked={props.type === type}
          />
        </ButtonContainer>
        <BodyContainer>
          {props.body.map((item) => (
            <Typography
              key={item}
              fontSize={14}
              fontWeight={600}
              color={
                props.description.toLowerCase().includes('smaller') &&
                (!(props.length === 2) || !item.includes(':'))
                  ? '$3D4D54'
                  : '#7DDD00'
              }
            >
              {item}
            </Typography>
          ))}
        </BodyContainer>
        {props.benefits.map((item) => (
          <Stack py={1.5} key={item.label}>
            <Typography key={item.label} fontSize={14} fontWeight={700}>
              {item.label}
            </Typography>
            {item.details.map((list) => (
              <Typography fontSize={14} key={list}>
                <FontAwesomeIcon
                  icon={faCheck as IconProp}
                  size="sm"
                  color="#7DDD00"
                />{' '}
                &nbsp;
                {list}
              </Typography>
            ))}
          </Stack>
        ))}
      </CardBody>
    </Stack>
  );
};
